export function PrivacyPolicy() {
  return (
    <div className="fixed inset-0 z-50 overflow-y-auto bg-background px-6 py-12">
      <div className="mx-auto max-w-2xl">
        <a
          href="/"
          className="text-muted-foreground text-sm hover:text-foreground"
        >
          &larr; Back
        </a>

        <h1 className="mt-6 font-semibold text-2xl">Privacy Policy</h1>
        <p className="mt-2 text-muted-foreground text-sm">
          Effective April 9, 2026
        </p>

        <div className="mt-8 space-y-6 text-sm leading-relaxed">
          <section>
            <h2 className="font-semibold text-base">Who we are</h2>
            <p className="mt-2 text-muted-foreground">
              Gnomux is operated by In Silico Industries Inc., a Canadian
              corporation. If you have questions about this policy, contact us
              at privacy@gnomux.com.
            </p>
          </section>

          <section>
            <h2 className="font-semibold text-base">What we collect</h2>
            <p className="mt-2 text-muted-foreground">
              When you sign in, we receive your name and email address from our
              authentication provider, Kinde. Authentication tokens are stored
              in your browser&apos;s local storage — we do not use cookies.
            </p>
            <p className="mt-2 text-muted-foreground">
              We store the DNA sequences and files you create or upload.
              Sequence data is stored in a PostgreSQL database and file uploads
              are stored in Amazon S3. Both are hosted in the United States.
            </p>
            <p className="mt-2 text-muted-foreground">
              We collect error reports through Sentry to diagnose and fix bugs.
              These reports may include your browser type, operating system, and
              the action that triggered the error.
            </p>
          </section>

          <section>
            <h2 className="font-semibold text-base">How we use your data</h2>
            <p className="mt-2 text-muted-foreground">
              Your data is used solely to provide and improve Gnomux. We do not
              sell, rent, or share your personal information with third parties
              for marketing purposes.
            </p>
          </section>

          <section>
            <h2 className="font-semibold text-base">Third-party services</h2>
            <p className="mt-2 text-muted-foreground">
              We use the following services to operate Gnomux:
            </p>
            <ul className="mt-2 list-inside list-disc text-muted-foreground">
              <li>
                <strong>Kinde</strong> — authentication and user management
              </li>
              <li>
                <strong>Railway</strong> — database and application hosting (US)
              </li>
              <li>
                <strong>Amazon S3</strong> — file storage (US)
              </li>
              <li>
                <strong>Sentry</strong> — error monitoring
              </li>
            </ul>
          </section>

          <section>
            <h2 className="font-semibold text-base">
              Data retention and deletion
            </h2>
            <p className="mt-2 text-muted-foreground">
              Your data is retained for as long as your account is active. You
              may request deletion of your account and all associated data by
              contacting us at privacy@gnomux.com. We will process deletion
              requests within 30 days.
            </p>
          </section>

          <section>
            <h2 className="font-semibold text-base">Changes to this policy</h2>
            <p className="mt-2 text-muted-foreground">
              We may update this policy from time to time. If we make
              significant changes, we will notify you through the application.
            </p>
          </section>
        </div>
      </div>
    </div>
  );
}
